import getUrlParameters from '../../../utils/getUrlParameters';
import type { Tab } from '../../types/Tab';
import type { WidgetProps } from '../../types/WidgetProps';
import { WidgetType } from '../../types/WidgetType';
import { TechRadar } from '../sites/definitions/TechRadar';
import { TechRadarPro } from '../sites/definitions/TechRadarPro';

export const getWidgetTypeComponent = (props: WidgetProps, defaultTab: Tab | null): WidgetType => {
  const { params, site, editorial, widget, name } = props;
  /**
   * Use the provided widget type unless:
   * - the widget type was forced in the url for debugging
   * - the site is Techradar, the article is phones, it's a review widget
   * - the platform is responsive, the article is a retail review, it's a review widget
   * - there are game platform tabs and it's a review widget
   * */
  const { widgetType: urlWidgetType } = getUrlParameters(['widgetType']);
  if (urlWidgetType) {
    return urlWidgetType as WidgetType;
  }

  if (
    [TechRadar, TechRadarPro].includes(site) &&
    widget.type === WidgetType.REVIEW &&
    defaultTab &&
    defaultTab.value === 'contracts'
  ) {
    return WidgetType.POCKET;
  }
  if (
    site.platform === 'responsive' &&
    params.article_type === 'review' &&
    defaultTab?.value === 'deals' &&
    widget.type === WidgetType.REVIEW &&
    !editorial &&
    name !== 'BOT widget'
  ) {
    return WidgetType.MERCHANT_LINK;
  }
  if (
    defaultTab &&
    defaultTab.type === 'label_text_game_platform' &&
    widget.type === WidgetType.REVIEW
  ) {
    return WidgetType.TABS;
  }
  if (
    params.article_type === 'buying_guide' &&
    widget.type === WidgetType.MERCHANT_LINK &&
    defaultTab &&
    defaultTab.value === 'subscriptions'
  ) {
    return WidgetType.PRICE;
  }

  return widget.type;
};
